import React from 'react';
import { api, PortalContext } from '@portal/arq-portal-core';
import { makeStyles, TextField, Button } from '@material-ui/core';
import { ComentarioCompleto } from './ComentarioCompleto';
const useStyles = makeStyles(theme => ({
    linea: {
        padding: theme.spacing(1)
    },  
    elem: {
        display: 'flex',
        flexDirection: 'row',
        marginBottom: '30px',
        width: '100%',
        borderBottom: '1px solid #d6d8d8'
    },
    elemHeader: {
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'row'
    },
    time: {
        color: '#b1b2b2',
        fontSize: '12px',
        width: 'calc(100% - 130px)',
        marginBottom: '10px'
    },
    actions: {
        alignItems: 'center',
        flexDirection: 'row',
        display: 'flex',
        marginBottom: '15px',
        [`& i`]: {
            fontSize: '24px', 
            marginRight: '2px'
        },
        [`& .icon-pro-like`]: {
            cursor: 'pointer'
        },
        [`& .icon-chat`]: {
            cursor: 'pointer'
        },
        [`& .is-liked`]: {
            color: '#DC0028'
        },
        [`& span`]: {
            fontSize: '14px',
            marginRight: '17px'
        }
    },
    content: {},
    user: {
        fontWeight: 'bold', 
        color: '#606060',
        fontSize: '16px',
        marginBottom: '10px',
        marginTop: '-5px'
    },
    place: {
        color: '#b1b2b2',
        fontSize: '14px',
        marginBottom: '15px'
    },
    comment: {
        marginTop: '5px',
        marginBottom: '15px',
        fontSize: '15px',
        color: '#606060'
    },
    likeDiv: {
        display: 'flex',
        alignItems: 'center'
    }, 
    comName: {
        display: 'flex',
        justifyContent: 'space-between',
        width: '100%', 
        alignItems: 'start',
        minHeight: '30px'
    },
    community: {
        width: 'auto',
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        flexDirection: 'row',
        float: 'left',
        marginRight: '2rem',
        [`& span`]: {
            fontSize: '13px',
            color: '#606060',
            textTransform: 'capitalize',
        },
        [`& .COMM_AGENTES`]: {
            border: '2px solid #94ccda',
        },
        [`& .COMM_GENERALES`]: {
            border: '2px solid #f9d4b6',
        },
        [`& .COMM_VIDA`]: {
            border: '2px solid #cbc0d7',
        },
        [`& .COMM_COMUN`]: {
            border: '2px solid #c4bd98',
        },
        [`& .COMM_COMERCIAL`]: {
            border: '2px solid #d6e2be',
        },
    },
    deleteEntry: {
        float: 'right',
        position: 'relative',
        [`& .icon-papelera`]: {
            cursor: 'pointer',
            fontSize: '30px'
        },
    },
    comCircle: {
        display: 'block',
        width: '10px',
        height: '10px',
        borderRadius: '50%',
        marginRight: '5px',
        float: 'left',
    },
    userPic: {
        width: '90px',
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        flexDirection: 'column',
        float: 'left',
        [`& img`]: {
            width: '50px',
            height: 'auto',
            display: 'block',
            maxWidth: '100%'
        },
        [`& .icon-estrella`]: {
            fontSize: '17px',
            color: '#606060',
            marginRight: '5px',
            '&:last-child': {
                marginRight: '0'
            }
        },
    }, 
    userInfo: {
        width: 'calc(100% - 90px)',
    },
    profileImgWrapper: {
        width:'50px',
        maxHeight: '50px',
        overflow: 'hidden',
        borderRadius: '50%',
        border: '1px solid #d6d8d8',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    },
    contStars: {
        display: 'flex', 
        justifyContent: 'center',
        marginTop: '5px',
        [`& .star-filled`]: {
            color: '#dc0028'
        }
    }, 
    verMas: {
        color: '#606060',
        cursor: 'pointer',
        fontSize: '14px',
        '&:hover': {
            color: '#919191',
        }
    },
    entry: {
        width: '100%', 
        marginBottom: '20px', 
        border: 'none', 
        backgroundColor: '#fff',
        minHeight: '105px',
        [`& input`]: {
            fontSize: '14px',
        },
        [`& fieldset`]: {
            borderRadius: 0,
            minHeight: '105px',
        },
        [`& .MuiInputBase-root`]: {
            minHeight: '105px',
        },
        [`& textarea#comentario`]: {
            fontSize: '14px',
            minHeight: '105px',
        },
    },
    comentarios: {
        display: 'flex', 
        flexDirection: 'column', 
        margin: '10px 0px 15px',
        padding: '20px',
        backgroundColor: '#f4f4f4'
    },
    publicarComentario: {
        width: '150px', 
        background: '#606060', 
        color: '#fff', 
        borderRadius: '0', 
        fontWeight: 'bold', 
        float: 'right',
        marginLeft: '10px',
        padding: '2px 8px',
        '&:hover': {
            background: '#919191',
        },
        '&.disabled': {
          color: '#fff'
        }
    },
    cancelComentario: {
        width: '150px', 
        background: '#fff', 
        color: '#606060', 
        border: '2px solid #606060',
        borderRadius: '0', 
        fontWeight: 'bold', 
        float: 'right',
        padding: '2px 8px',
        '&:hover': {
            color: '#919191',
            borderColor: '#919191',
            background: '#fff'
        }
    },
    commentCont: {        
        marginTop: '20px',
    },
    showComment: {
        display: 'flex',
        alignItems: 'center'
    },
    commentDiv: {
        paddingRight: '90px',
    },
    buttonCont: {
        display: 'flex',
        justifyContent: 'end',
        width: '100%'    
    },
    verPubli: {
        color: '#dc0028',
        fontSize: '14px',
        marginBottom: '15px',
        cursor: 'pointer'
    },
    checkDelete: {
        position: 'absolute',
        width: '150px',
        top: '30px',
        right: '0',
        display: 'flex',
        fontSize: '14px',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '5px',
        boxShadow: '6px 4px 10px #d6d8d8',
        [`& i`]: {
            fontSize: '25px',
            cursor: 'pointer'
        },
        [`& span`]: {
            paddingRight: '4px'
        },
    }
}));

export function ElementoCompleto(props: any): JSX.Element {
    
    const { elemento, deleteelement, selectedcom, agentesComunityId} = props;
    const classes = useStyles();
    const [currentPage, setCurrentPage] = React.useState(1);
    const [commentValue, setCommentValue] = React.useState('');
    const [showNewCom, setShowNewCom] = React.useState(false);
    const [showCheckDelete, setShowCheckDelete] = React.useState(false);
    const [canLike, setCanLike] = React.useState(elemento.CanLike);
    const [nLikes, setNlikes] = React.useState(elemento?.Likes? elemento.Likes.length : 0);
    const [comments, setComments] = React.useState(elemento && elemento.WallComments? elemento.WallComments : []);
    const { ciaGestiona } = React.useContext(PortalContext);

    var urlParams = new URLSearchParams(window.location.search);
    var ciaUrl = urlParams.get('cia');
    let cia = (ciaUrl === 'SCO' || ciaUrl === 'SBI' || ciaUrl === 'SPU') ? ciaUrl : ciaGestiona;

    const server = api.getApiServer();
    const getProfileImageUrl = (userCode:string) => `${server}/UserImage/${userCode}/`;
    let userLog = elemento?.User.UserLogin.split("\\");
    const userImg = getProfileImageUrl(userLog[userLog.length - 1]);

    React.useEffect(()=>{
        setCanLike(elemento && elemento.CanLike);
        setNlikes(elemento && elemento.Likes ? elemento.Likes.length : 0);
        setComments(elemento && elemento.WallComments? elemento.WallComments:[]);
        setCurrentPage(1);        
    },[elemento]);

    const likeElement = (event: any) => {
        event.stopPropagation();

        let jsonLike = {
            WallElementId: elemento.WallElementId,
            Title: elemento.User.UserName,
            Body: elemento.ShortBody,
            AllowComments: true,
            Type: "LIKE"
        };
    
        api.post('/be/piupointcreateordeletelike/', {"Entrada": {"json": JSON.stringify(jsonLike),"cia": cia}}).then(() => {
            canLike?setNlikes(nLikes + 1): setNlikes(nLikes - 1);
            setCanLike(!canLike);
        });
    };

    const showMoreComments = () => {
        setCurrentPage(currentPage + 1);
        api.post('/be/piupointgetwallcomments/', {"Entrada": {
            "page": currentPage + 1,
            "pageSize": 3,
            "communityId": selectedcom,
            "wallContentId": elemento.WallElementId,
            "isMockup": false,
            "cia": cia
        }}).then((wallComments:any)=>{
            let tmp = (wallComments && wallComments.Salida && wallComments.Salida.response)? JSON.parse(wallComments.Salida.response) : [];
            setComments(tmp.concat(comments));
        });
    };

    const showNewCommentBox = () => {
        setShowNewCom(true);
    };

    const cancelComment = () => {
        setShowNewCom(false);
    };

    const publishComment = () => {
        let jsonNew = {
            WallElementId: elemento.WallElementId,
            Title: "",
            Body: commentValue,
            AllowComments: true,
            Type: "COMMENT",
            CommentBody: commentValue
        };
    
        api.post('/be/piupointcreatewallcomment/', {"Entrada": {"json": JSON.stringify(jsonNew),"cia": cia}}).then((wallComments) => {
            let updatedComments = (wallComments && wallComments.Salida && wallComments.Salida.response)? JSON.parse(wallComments.Salida.response) : [];
            setComments(updatedComments.WallComments);
            setCommentValue('');
        });
    }

    const deleteComment = (commentId: number) => {

        let jsonLike = {
            ContentId: commentId,
        };
        api.post('/be/piupointdeletewallcomment/', {"Entrada": {"json": JSON.stringify(jsonLike)}}).then(() => {
            let deletedComIndex = comments?.findIndex((com: any) => (com.WallCommentId == commentId));
            let aux = comments;
            aux.splice(deletedComIndex,1);
            setComments([]);
            setComments(aux);
        });
    };
    
    const handleComChange = (event: any) => {
        setCommentValue(event.target.value);
    };

    const handleDeleteElement = (event: any, WallElementId: number) => {
        deleteelement(event, WallElementId);
        setShowCheckDelete(false);
    }

    const getTimeDiff = (CreationDate: string) => {

        let today = new Date();
        let created = new Date(CreationDate + 'Z');
        let hours = 0;
        let minutes = 0;
        let days = 0;
        let month = 0;
        let years = 0;

        const timeDiff = today.getTime() - created.getTime();
        minutes = Math.floor(timeDiff / (1000 * 60));
        hours = Math.floor(timeDiff / (1000 * 60 * 60));
        days = Math.floor(timeDiff / (1000 * 60 * 60 * 24));
        month = (today.getMonth() + 1) - (created.getMonth() + 1) + (12 * (today.getFullYear() - created.getFullYear()));
        years = today.getFullYear() - created.getFullYear();

        /*console.log(CreationDate + ' CreationDate');
        console.log(minutes + ' minutes');
        console.log(hours + ' hours');
        console.log(days + ' days');
        console.log(month + ' months');
        console.log(years + ' years');
        console.log('-----------------------------------------------------------');*/

        if (minutes < 60) {
            return ` ${minutes === 1 ? 'un' : `${minutes}`} minuto${minutes === 1 ? '' : 's'}`;
        } else if (hours < 24) {
            return ` ${hours === 1 ? 'una' : `${hours}`} hora${hours === 1 ? '' : 's'}`;
        } else if (days < 30) {
            return ` ${days === 1 ? 'un' : `${days}`} día${days === 1 ? '' : 's'}`;
        } else if (month < 12) {
            return ` ${month === 1 ? 'un' : `${month}`} mes${month === 1 ? '' : 'es'}`;
        } else {
            return ` ${years === 1 ? 'un' : `${years}`} año${years === 1 ? '' : 's'}`;
        }
    }

    return (
        <div className={classes.elem}>

            <div className={classes.userPic}>
                <div className={classes.profileImgWrapper}>
                    {selectedcom && selectedcom == agentesComunityId ?
                        <img src={userImg}></img>
                    :
                        <img src="/assets/defaultpic.png"></img>
                    }
                </div>
                {selectedcom && selectedcom == agentesComunityId &&
                    <div className={classes.contStars}>
                        <i className={`icon-estrella ${elemento?.User.Score > 0 ? `star-filled` : ``}`}></i>
                        <i className={`icon-estrella ${elemento?.User.Score > 1 ? `star-filled` : ``}`}></i>
                        <i className={`icon-estrella ${elemento?.User.Score > 2 ? `star-filled` : ``}`}></i>
                    </div>     
                }           
            </div>

            <div className={classes.userInfo}>
                <div className={classes.comName}>
                    <div className={classes.community}>
                        <i className={`${classes.comCircle} ${elemento?.Communities[0]?.UniqueName}`}></i>
                        <span>{elemento?.Communities[0]?.Name}</span>
                    </div>
                    <div className={classes.deleteEntry}>
                        {elemento?.CanDelete && <i className="icon-papelera" onClick={() => setShowCheckDelete(true)}></i>}
                        {showCheckDelete &&                       
                            <div className={classes.checkDelete}>
                                <span>¿Estás seguro?</span>
                                <i className="icon-accion-satis" onClick={(event) => handleDeleteElement(event, elemento.WallElementId)}></i>
                                <i className="icon-accion-insatis" onClick={() => setShowCheckDelete(false)}></i>
                            </div>
                        }
                    </div>
                </div>

                {selectedcom && selectedcom == agentesComunityId ?
                    <div className={classes.user}>{elemento?.User.UserName}</div>
                :
                    <div className={classes.user}>{elemento?.Title}</div>
                }

                {selectedcom && selectedcom == agentesComunityId &&
                    <div className={classes.place}>{elemento?.User.JobTitle}</div>    
                }

                {selectedcom && selectedcom == agentesComunityId ?
                    <div className={classes.comment}>{elemento?.ShortBody}</div>
                :
                    <div className={classes.comment} dangerouslySetInnerHTML={{ __html: elemento?.ShortBody}}></div>
                }          

                {selectedcom && selectedcom != agentesComunityId &&
                    <div className={classes.verPubli} onClick={()=> window.open(elemento?.Attachments[0]?.ExternalLink, "_blank")}>{elemento?.Attachments[0]?.Name}</div>
                }

                <div className={classes.time}>hace 
                    {getTimeDiff(elemento?.CreationDate)}
                </div>

                <div className={classes.actions}>
                    <i onClick={likeElement} className={`icon-pro-like ${!canLike ? `is-liked` : ``}`}></i>
                    <span className="inline">({nLikes})</span>
                    
                    {selectedcom && selectedcom == agentesComunityId &&
                        <div className={classes.showComment}>
                            {elemento?.CanComment && 
                                <div className={classes.likeDiv} onClick={showNewCommentBox}>
                                    <i className="icon-chat"></i>
                                    <span className="inline">
                                        ({elemento?.WallCommentsCount})
                                    </span>
                                </div>
                            }
                            {(elemento.WallCommentsPageCount > 1 && currentPage != elemento.WallCommentsPageCount) &&
                                <div className={classes.verMas} onClick={showMoreComments}>Ver más comentarios</div>}
                        </div>    
                    }
                </div>  

                {selectedcom && selectedcom == agentesComunityId &&
                    <div className={classes.commentDiv}>
                        <div className={classes.commentCont}>
                            {comments && comments.map((comment: any, i:any) => {                
                                return (<ComentarioCompleto key={i} elemento={comment} deletecomment={deleteComment} />)
                            })} 
                        </div>

                        {showNewCom && elemento.CanComment &&                
                            <div className={classes.comentarios}>
                                <TextField {...props} id="comentario" placeholder="Escribe una respuesta..." variant="outlined" size="small" multiline
                                    className={classes.entry}
                                    value={commentValue}
                                    onChange={handleComChange}
                                />
                                <div className={classes.buttonCont}>
                                    <Button variant="text" onClick={cancelComment} className={classes.cancelComentario}>
                                        Cancelar
                                    </Button>
                                    <Button disabled={commentValue === ''} variant="text" onClick={publishComment} className={`${classes.publicarComentario} ${commentValue === '' ? `disabled` : ``}`}>
                                        Enviar
                                    </Button>
                                </div>
                            </div>
                        }
                    </div>
                }
            </div>         
        </div>
    )
}